import mlaStyle from "../../assets/styles/modern-language-association-8th-edition.csl";
import chicagoStyle from "../../assets/styles/chicago-note-bibliography.csl";
import Cite from "citation-js";

// Function to initialize citation data fields
export function initializeCitationData(
  fields,
  prevCitationData = {},
  retainValues = false
) {
  const arr = fields?.optional
    ? fields?.required.concat(fields?.optional)
    : fields?.required;

  return arr?.reduce((acc, field) => {
    if (retainValues && field in prevCitationData) {
      // Retain the previous value if the field exists in the previous data
      acc[field] = prevCitationData[field];
    } else if (field === "issued" || field === "accessed") {
      // Initialize with a date structure if it's a date field
      acc[field] = { "date-parts": [[]] };
    } else {
      // Otherwise, initialize with an empty string
      acc[field] = "";
    }
    return acc;
  }, {});
}
export const addCustomStyles = async () => {
  // Get styles
  let config = Cite.plugins.config.get("@csl");

  if (!config?.templates?.has("mla")) {
    const response = await fetch(mlaStyle);
    const mlaStyleText = await response.text();
    config?.templates?.add("mla", mlaStyleText);
  }

  if (!config?.templates?.has("chicago")) {
    const response = await fetch(chicagoStyle);
    const chicagoStyleText = await response.text();
    config?.templates?.add("chicago", chicagoStyleText);
  }
};
export const resetCitationDataValues = (
  setGeneratedCitation,
  setAuthors,
  citationData,
  setCitationData
) => {
  setGeneratedCitation("");
  setAuthors([{ given: "", family: "" }]);
  const resetValues = Object.fromEntries(
    Object.keys(citationData).map((key) => {
      if (key === "issued" || key === "accessed") {
        // Preserve the date structure
        return [key, { "date-parts": [[]] }];
      } else if (key === "author") {
        // Reset the author field to an empty array with an empty object
        return [key, [{ given: "", family: "" }]];
      } else {
        // Reset other values to empty strings
        return [key, ""];
      }
    })
  );

  setCitationData(resetValues);
};

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(() => {
    //   alert("copied to clipboard!");
  });
}

export const generateUrl = (url_ids) => {
  // Define the base URLs for each platform
  const amazonUrl = "https://www.amazon.com/dp/";
  const goodreadsUrl = "https://www.goodreads.com/book/show/";
  const libraryThingUrl = "https://www.librarything.com/work/";
  const overdriveUrl = "https://www.overdrive.com/media/";

  // Check each ID and return the corresponding URL if available
  switch (true) {
    case Boolean(url_ids?.id_amazon):
      return amazonUrl + url_ids.id_amazon;
    case Boolean(url_ids?.id_goodreads):
      return goodreadsUrl + url_ids.id_goodreads;
    case Boolean(url_ids?.id_librarything):
      return libraryThingUrl + url_ids.id_librarything;
    case Boolean(url_ids?.id_overdrive):
      return overdriveUrl + url_ids.id_overdrive;
    default:
      return "";
  }
};
